export default {
  labels: {
    free_items: 'Gratis',
    bogo: 'Kaufe 1, Erhalte 1 Gratis',
    order_again: 'Nochmal bestellen',
  },
};
